import React from "react";
import {FunctionComponent} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {Promotion, PromotionVariant} from "./Promotion";

interface IProps {
    promotions: {
        description: string | null;
        id: number;
        name: string;
        type: number;
    }[];
    vendorId: number;
    offerName: string;
    offerId?: number;
    propertyId?: number;
    isAutoresponderEnabled: boolean;
    isSaleOverLimit?: boolean;
    variant?: PromotionVariant;
}

export const Promotions: FunctionComponent<IProps> = (props) => {
    const {promotions, variant} = props;

    return (
        <>
            <Text as="h2" variant="headline_4" className={promotionsHeaderStyle}>
                Promocje
            </Text>

            <ul className={promotionsListStyle}>
                {promotions.map((promotion) => (
                    <Promotion
                        key={promotion.id}
                        promotion={promotion}
                        vendorId={props.vendorId}
                        offerName={props.offerName}
                        offerId={props.offerId}
                        propertyId={props.propertyId}
                        isAutoresponderEnabled={props.isAutoresponderEnabled}
                        isSaleOverLimit={props.isSaleOverLimit}
                        variant={variant}
                    />
                ))}
            </ul>
        </>
    );
};

const promotionsHeaderStyle = css({
    m: "0 0 2.4rem 0"
});

const promotionsListStyle = css({
    listStyle: "none",
    m: 0,
    p: 0
});
import React from "react";
import {FunctionComponent} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {Promotion, PromotionVariant} from "./Promotion";

interface IProps {
    promotions: {
        description: string | null;
        id: number;
        name: string;
        type: number;
    }[];
    vendorId: number;
    offerName: string;
    offerId?: number;
    propertyId?: number;
    isAutoresponderEnabled: boolean;
    isSaleOverLimit?: boolean;
    variant?: PromotionVariant;
}

export const Promotions: FunctionComponent<IProps> = (props) => {
    const {promotions, variant} = props;

    return (
        <>
            <Text as="h2" variant="headline_4" className={promotionsHeaderStyle}>
                Promocje
            </Text>

            <ul className={promotionsListStyle}>
                {promotions.map((promotion) => (
                    <Promotion
                        key={promotion.id}
                        promotion={promotion}
                        vendorId={props.vendorId}
                        offerName={props.offerName}
                        offerId={props.offerId}
                        propertyId={props.propertyId}
                        isAutoresponderEnabled={props.isAutoresponderEnabled}
                        isSaleOverLimit={props.isSaleOverLimit}
                        variant={variant}
                    />
                ))}
            </ul>
        </>
    );
};

const promotionsHeaderStyle = css({
    m: "0 0 2.4rem 0"
});

const promotionsListStyle = css({
    listStyle: "none",
    m: 0,
    p: 0
});
